import React from 'react'
import './ScrollToTop.css'
function ScrollTo() {
    React.useEffect(() => {
        let span = document.querySelector(".up");
        window.onscroll = function () {
            this.scrollY >= 1000 ? span.classList.add("show") : span.classList.remove("show");
        };
        span.onclick = function () {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        };
    }, []);
    const bottomToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
    return (
        <span onClick={bottomToTop} className="up">
            &#8593;
        </span>
    )
}

export default ScrollTo